import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { InvestmentPaths } from '../investments.types';
import { useIsModelChangedStore } from '../stores';

import useInvestorQuery from './useInvestor.query';

interface InvestmentPathPayload {
  option: InvestmentPaths;
}
interface Params {
  onSuccess: () => void;
  onError: () => void;
}
const useInvestmentsPathQuery = (params?: Params) => {
  const {
    data: { type },
  } = useInvestorQuery();

  const setModelChanged = useIsModelChangedStore((state) => state.setModelChanged);
  const { mutateAsync, isLoading, isSuccess } = useMutation(
    ({ option }: InvestmentPathPayload) => {
      if (option !== type) {
        setModelChanged(true);
      } else {
        setModelChanged(false);
      }
      return api.patch(
        API_URL.INVESTMENTS_FLOWS_PATH,
        {
          option,
        },
        {
          params: {
            terms_accepted: true,
          },
        }
      );
    },
    {
      onSuccess: () => {
        if (params?.onSuccess) {
          params?.onSuccess();
        }
      },
      onError: params?.onError,
    }
  );
  return {
    handleSave: mutateAsync,
    isLoading,
    isSuccess,
  };
};

export default useInvestmentsPathQuery;
